import { Scene } from 'phaser';
import { DPR } from "./helpers";
export class PreloadScene extends Scene {
    preload() {
        let progressDisplay = 0;
        let loadCompleted = false;
        this.multiLangFilesLoading = 0;
        
        let callback = 
            () => {
                let timer = this.time.addEvent({
                    delay: 25,                // ms
                    callback: () => {
                        if(progressDisplay < 1) {
                            if(progressDisplay < this.load.progress || !this.load.progress){
                                progressDisplay+=0.01;
        
                                GameLoader.setPercentage(Math.round(progressDisplay * 100));
                            }
                        } else {
                            if(!loadCompleted || this.multiLangFilesLoading) {
                                return;
                            }
        
                            timer.remove();
                            
                            GameLoader.finishLoader(() => {
                                this.scene.start('GameScene');
                            });
                        }
                    },
                    callbackScope: this,
                    loop: true
                });
            };
        
        GameLoader.initLoader(callback);

        document.getElementById('fg-container').classList.add('loading'); 

        this.load.on('complete', () => {
            loadCompleted = true;
        });
        
        this.load.path = `/fg/v2/games/${Config.game_name.toLowerCase()}/`;
        for (const [ type, items ] of Object.entries(Config.assets)) {
            for (const [ name, fileName ] of Object.entries(items)) {
                //console.log(`Loading from ${type} name is ${name}...`);

                if(['images', 'spritesheets', 'atlas'].includes(type)) {
                    this.loadAfterTransform(type, name, fileName);
                } else {
                    this.loadFile(type, name, fileName);
                }
            }
        }
    }

    loadFile(type, name, fileName) {
        switch (type) {
            case 'images':
                this.load.image(name, fileName);
                break;
            case 'sounds':
                this.load.audio(name, fileName);
                break;
            case 'spritesheets':
                const blocks = fileName.split('_').map(num => parseInt(num));

                const frameHeight = blocks.pop();
                const frameWidth = blocks.pop();

                this.load.spritesheet(name, fileName, { frameWidth, frameHeight });
                break;
            case 'fonts':
                this.load.bitmapFont(name, `${fileName}.png`, `${fileName}.xml`);
                break;
            case 'multiatlas':
                this.load.multiatlas(name, fileName, `${this.load.path}img/`);
                break;
            case 'atlas':
                this.load.atlas(name, `${fileName}.png`, `${fileName}.json`);
                break;
            case 'spines':
                this.load.spine(name, `${fileName}.json`, [ `${fileName}.atlas` ], true);
                break;
            case 'multi_format_sounds':
                this.addMultiFormatSound(name, fileName);
                break;
            case 'multi_format_sounds':
                this.addMultiFormatSound(name, fileName);
                break;
            case 'multi_images':
                this.addMultiImages(name, fileName);
                break;
        }
    }

    loadAfterTransform(type, name, fileName) {
        let needReplace = fileName.search('--language--');

        if(needReplace !== -1) {
            let newFileName = fileName.replace('--language--', Config.language);
            this.multiLangFilesLoading++;

            this.doesFileExist(this.load.path + newFileName)
                .then(
                    () => {fileName = newFileName; this.loadFile(type, name, fileName); this.multiLangFilesLoading--;}, 
                    () => {fileName = fileName.replace('--language--', 'en'); this.loadFile(type, name, fileName); this.multiLangFilesLoading--;}
                );
        } else {
            this.loadFile(type, name, fileName);
        }

        /*if(DPR > 1) {
            let splitted = fileName.split('.');
            
            return `${splitted[0]}@${DPR}x.${splitted[1]}`;
        }*/

    }

    addMultiFormatSound(name, folderName) {
        let format = "mp3";

        if(this.sys.game.device.audio.ogg) {
            format = "ogg";
        } else if(this.sys.game.device.audio.m4a) {
            format = "m4a";
        }

        this.load.audio(name, `${folderName}${format}/${name}.${format}`);
    }
    
    doesFileExist(url) {
        return new Promise(function (resolve, reject) {
            let img = new Image();
            img.onerror = img.onabort = function () {
                reject();
            };
            img.onload = function () {
                resolve();
            };

            img.src = url;
        });
    }

    addMultiImages(name, fileInfo) {
        for (let i = fileInfo['from']; i <= fileInfo['to']; i++) {
            const appendedName = `${name}_${i}`;
            const fileName = fileInfo['asset'].replace('--counter--', i);
            this.loadFile(fileInfo['type'], appendedName, fileName);
        }
    }
}